import { Address } from '@generated/gql/graphql';

const addressFields: Array<keyof Address> = [
  'uprn',
  'postcode',
  'subBuilding',
  'buildingName',
  'buildingNumber',
  'thoroughfare',
  'postTown',
  'county',
  'dependentThoroughfare',
  'organisation',
  'department',
  'dependentLocality',
  'doubleDependentLocality',
];

export const FORM_ADDRESS_PAGE = 'addressPage';
export const FORM_ABOUT_PREVIOUS_ADDRESS = 'aboutPreviousAddress';
export const FORM_DD_BILLING_ADDRESS = 'ddBillingAddressForm';

export { addressFields };
